import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { get,post } from '../../../../../Model/Network/Config/Axios';
import { SearchableSelect } from '../../../../Common/Class/Select/SearchableSelec2';
import { FunctionalInput } from '../../../../Common/fInputs';
import { Modal } from '../../../../Common/fModal/Modal';
import { handleError, showToast } from '../../../../Common/fToast/ToastCallback';
import { LineHeader } from '../../../../Header/LineHeader';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { DEV_MODE } from '../../../../../Model/Network/Api/config';



const Tds = (props) => {


    const [tds,setTds] = useState([]);
    const [tdsMode,setTdsMode] = useState('percentage');
    const [changeTds,setChangeTds] = useState(false);
    const [allTds,setAllTds] = useState([]);
    const [selectedTds,setSelectedTds] = useState(false);
    const Amount = useRef(),CODE=useRef();
	const {onlyGlobalTdsMaster,tdsEntitySegregated} = useSelector((state) => state.auth.config.plugins);
    let  id= +props.id;
	let {vendorId,vendor} =props
	let Dev_Mode_Check = (DEV_MODE || window.location.href.includes("localhost")) // dev mode check needs to be removed once it is done from BE on prod

	let fetchAllTds=()=>{
		if (onlyGlobalTdsMaster) {
			get(`vendor/config/tds/allTdsMaster`, (e, r) => {
				if (r) {
					const individualHufTypes = vendor && vendor.pan && ["P", "H", "B"].includes(vendor.pan.charAt(3));
					setAllTds(r.tds.map(val => ({
						id: val.id,
						label: val.section,
						des: val.description,
						tax: individualHufTypes ? val.individualHufRate:  val.otherRate,
						type:'master'
					})))
				}
			})
		} else {
			get(`vendor/contacts/${vendorId}/details`,(e1,r1)=>{
				if(r1) {
					get(`/vendor/config/tds/all`,(e,r)=>{
						if (r) {
							if(r1.config.tdsIds.length) {
								setAllTds(r.tds.filter(item=>_.includes(r1.config.tdsIds,item.id)).map(val=>({
									id: val.id,
									label: val.code,
									des: val.description,
									tax: val.tax
								})))
							} else {
								setAllTds(r.tds.map(val=>({
									id: val.id,
									label: val.code,
									des: val.description,
									tax: val.tax
								})))
							}
							
						}
					})
				}
			})
		}
	}
	
    useEffect(()=>{
		if(Dev_Mode_Check && tdsEntitySegregated && props && props.entityId){
			get(`vendor/config/tds/${props.entityId}/allTdsMasterV2`, (e, r) => {
				if (r) {
					if(r.tds && r.tds.length){
						const individualHufTypes = vendor && vendor.pan && ["P", "H", "B"].includes(vendor.pan.charAt(3));			
						setAllTds(r.tds.map(val => ({
							id: val.id,
							label: val.section,
							des: val.description,
							tax: individualHufTypes ? val.individualHufRate:  val.otherRate,
							type:'vcTdsMaster'
						})))
					}
					else{
						fetchAllTds()
					}
				}
				else if(e){
					handleError(e)
				}
			})
		}	
		else{
			fetchAllTds()
		}
    },[])

    return(
        <>      
                <div style={{marginTop:0}}>
                    <p style={{marginBottom:10}}>Tds</p>
                    <div style ={{
                        height:40,
                        background:'var(--off-white)',
                        border:'1px solid var(--border-color)',
                        width:'100%',
                        padding:10,
                        fontSize:12,
                        color:'var(--text-color)'
                    }} onClick={()=>{
						if(props.disabled) return;
                        setChangeTds(true);
                    }}>
                        {props.value?props.value.toFixed(2):props.value}
                    </div>
                </div>
                {
					changeTds ?
						<Modal
							onSave={() => {
								if (tdsMode === 'percentage') {
									if (!selectedTds) {
										showToast({
											type: 'error',
											value: 'Please enter some value'
										})
										return;
									}
									let key='tds'
									let billDate=undefined
									if(Dev_Mode_Check){
										billDate=moment(props.billDate).format("YYYY-MM-DD")
									}
									if(selectedTds && selectedTds.type && selectedTds.type==="master"){
										key='tdsMaster';
									}
									else if(selectedTds && selectedTds.type && selectedTds.type==="vcTdsMaster"){
										key='vcTdsMaster';
									}
									post(`/vendor/invoicing/${id}/change`, {
										key: key,
										value: `${selectedTds.id}`,
										billDate:billDate
									}, (e, r) => {
										if (r) {
											props.init();
										} else {
											handleError(e)
										}
									})
                                    setChangeTds(false);
									showToast({
										type: 'success',
										message: "Field update successfully"
									})
								} else {
									let amount = Amount.current.value;
									let code = CODE.current.value;
									if (!amount) {
										showToast({
											type: 'error',
											message: "Please enter the amount"
										})
										return;
									}
									if(!code) {
										showToast({
											type: 'error',
											message: "Please enter the remarks"
										})
										return;
									}
									post(`/vendor/invoicing/${id}/change`, {
										key: 'tds.fixed',
										value: amount,
										code
									}, (e, r) => {
										if (r) {
											props.init();

										} else {
											handleError(e)
										}
									})
                                    setChangeTds(false);
									showToast({
										type: 'success',
										message: "Field update successfully"
									})
								}
							}}
							style={{
								save: {
									padding: '12px 15px',
									width: '100%',
									textAlign: 'center',

								}
							}}
							show={true}
							title="Change Tds"
							des="Change Tds"
							close={() => {
                                setChangeTds(false);
							}}
							buttonName="Change Tds "
						>
							<LineHeader
								items={
									[
										{
											name: 'Select Percentage',
											active: tdsMode === 'percentage',
											click: () => {
                                                setTdsMode('percentage');
											}
										},
										{
											name: 'Select Amount',
											active: tdsMode === 'amount',
											click: () => {
                                                setTdsMode('amount');
											}
										},

									]
								}
							/>
							<div style={{
								marginTop: 20
							}}/>
							{
								tdsMode === 'percentage' ?
									<SearchableSelect
										reset={()=>{setTds(allTds)}}
										disabled={props.disabled}
										label="Select Tds"
										placeholder="Select Tds"
										onChange={val => {
											if (val.length > 0) {
												let allItems = allTds.filter(item => {
													if (item.label.toLowerCase().includes(val)) {
														return true
													}
													if (item.des.toLowerCase().includes(val)) {
														return true;
													}
													if (String(item.tax).toLowerCase().includes(val)) {
														return true
													}
													return false;
												})
                                                setTds(allItems);
											} else {
                                                setTds(allTds);
											}
										}}
										select={selectedTds => {
                                            setSelectedTds(selectedTds);
										}}
										value={selectedTds}
										items={tds}
									/>
									: tdsMode === 'amount' ?
									<>
									<FunctionalInput disabled={props.disabled} type="number" title="Enter Amount"
												ref={Amount}/>
									<FunctionalInput disabled={props.disabled} type="text" title="Remarks"
												ref={CODE}/>
									</>
									:
									null

							}
						</Modal>
						: null
				}

        </>
    )
}

export default Tds;